module.exports = __webpack_public_path__ + "static/media/zooplankton.41577e0d.jpg";